module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-900.d8eab344.woff2";